import React, { useEffect } from "react";
import DisplayField from "./DisplayField";
import ActivityCard from "./ActivityCard";

function EventActivityCard({ item = {}, prepareDocumentData }) {
    const dataRef = React.useRef(null);
    useEffect(() => {
        // Removing right side virtualEventLink data
        // if (item.virtualEventLink) {
        //     dataRef.current = dataRef.current || {};
        //     dataRef.current["Virtual Event Link"] = {
        //         value: item.virtualEventLink,
        //         type: "button",
        //         side: "right",
        //         order: 10,
        //     };
        // }

        prepareDocumentData(item.id, dataRef.current);
    }, [item]);

    const prepareLeftData = (key, value, order, mainText) => {
        dataRef.current = dataRef.current || {};
        if (mainText) {
            value.value = mainText;
        }
        dataRef.current[key] = { ...value, side: "left", order };
    };
    const prepareRightData = (key, value, order, mainText) => {
        dataRef.current = dataRef.current || {};
        if (mainText) {
            value.value = mainText;
        }
        dataRef.current[key] = { ...value, side: "right", order };
    };

    return (
        <ActivityCard
            // label="Event Activity"
            // icon={<EventIcon fontSize="small" sx={{ color: config.primaryColor }}></EventIcon>}
            subject={item.subject}
            date={item.departureStartTimeString}
            timezone={item.departureTimeZoneCode}
            detail={
                <>
                    {/* <DisplayField
                        label="Start"
                        type="LocationTime"
                        date={item.departureStartTimeString}
                        timezone={item.departureTimeZoneCode}
                        prepareData={(key, value) => prepareLeftData(key, value, 1)}></DisplayField> */}
                    {/* <DisplayField
                        label="End"
                        type="LocationTime"
                        date={item.arrivalEndTimeString}
                        timezone={item.arrivalTimeZoneCode}></DisplayField> */}
                    {item.introducer && (
                        <DisplayField
                            label="Introducer"
                            type="Text"
                            text={`${item.introducer}`}
                            prepareData={(key, value) => prepareLeftData(key, value, 2)}></DisplayField>
                    )}
                    {item.moderator && (
                        <DisplayField
                            label="Moderator"
                            type="Text"
                            text={`${item.moderator}`}
                            prepareData={(key, value) => prepareLeftData(key, value, 3)}></DisplayField>
                    )}
                    {item.format && (
                        <DisplayField
                            label="Format"
                            type="Text"
                            text={`${item.format}`}
                            prepareData={(key, value) => prepareLeftData(key, value, 4)}></DisplayField>
                    )}
                    {item.attendee && (
                        <DisplayField
                            label="Attendees"
                            type="Text"
                            text={`${item.attendee}`}
                            prepareData={(key, value) => prepareLeftData(key, value, 5)}></DisplayField>
                    )}
                    {item.metBy && (
                        <DisplayField
                            label="Met By"
                            type="Text"
                            text={`${item.metBy}`}
                            prepareData={(key, value) => prepareLeftData(key, value, 6)}></DisplayField>
                    )}
                </>
            }
            // rightElement={
            //     <>
            //         {item.locationNotes && (
            //             <DisplayTextBox
            //                 title="Location"
            //                 value={item.locationNotes}
            //                 prepareData={(key, value) => prepareRightData(key, value, 1)}></DisplayTextBox>
            //         )}
            //         {item.confirmation && (
            //             <DisplayTextBox
            //                 title={"Confirmation #"}
            //                 value={item.confirmation}
            //                 prepareData={(key, value) => prepareRightData(key, value, 2)}
            //             />
            //         )}
            //         {item.avContact && (
            //             <DisplayTextBox
            //                 title={"AV Contact"}
            //                 value={item.avContact}
            //                 prepareData={(key, value) => prepareRightData(key, value, 3)}
            //             />
            //         )}
            //         {item.virtualEventLink && (
            //             <Button href={item.virtualEventLink} size="small" target="_blank" variant="outlined">
            //                 Virtual Event Link
            //             </Button>
            //         )}
            //     </>
            // }
            ></ActivityCard>
    );
}
export default EventActivityCard;
